import { PROCESSING_CONSOLIDATIONS, CLEAR_CONSOLIDATION_STATUS } from '../actions/consolidations';
import { withFulFilled, withPending, withRejected } from './commons';

const INITIAL_STATE = {
  simple: {
    running: false,
    // Erro aqui é um array porquê podemos ter mais de uma requisição por vez.
    error: [],
    // Status de resultado das requisições ( 0 | 1 ), indica que pelo menos uma requisição teve status
    // code 200.
    status: undefined,
  },
};

function processingConsolidationsPending(state) {
  return {
    ...state,
    simple: {
      ...state.simple,
      running: true,
    },
  };
}

function processingConsolidationsFulfiled(state, action) {
  return {
    ...state,
    simple: {
      ...state.simple,
      running: false,
      status: action.payload.status,
    },
  };
}

function processingConsolidationsRejected(state, action) {
  return {
    ...state,
    simple: {
      ...state.simple,
      ...(typeof action.payload.status !== 'undefined'
        ? { status: action.payload.status }
        : {}),
      running: false,
      error: [...action.payload.error],
    },
  };
}

function clearConsolidationStatus(state) {
  return {
    ...state,
    simple: {
      ...state.simple,
      error: [],
      status: undefined,
    }
  }
}

const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case withPending(PROCESSING_CONSOLIDATIONS):
      return processingConsolidationsPending(state);
    case withFulFilled(PROCESSING_CONSOLIDATIONS):
      return processingConsolidationsFulfiled(state, action);
    case withRejected(PROCESSING_CONSOLIDATIONS):
      return processingConsolidationsRejected(state, action);
    case CLEAR_CONSOLIDATION_STATUS:
      return clearConsolidationStatus(state);
    default:
      return state;
  }
};

export default execute;
